import script from "./SubmissionTableClientCsv.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmissionTableClientCsv.vue?vue&type=script&setup=true&lang=js"

import "./SubmissionTableClientCsv.vue?vue&type=style&index=0&id=61189abd&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61189abd"]])

export default __exports__